/* import __COLOCATED_TEMPLATE__ from './label.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { ContentValue } from '@glint/template';

interface BvChoiceLabelSignature {
  Args: {
    disabled?: boolean;
    id?: string;
    label?: ContentValue;
    labelClass?: string;
    labelHidden?: boolean;
    onClick: () => void;
    onMouseOut: () => void;
    onMouseOver: () => void;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLLabelElement;
}

const BvChoiceLabelComponent = templateOnlyComponent<BvChoiceLabelSignature>();

export default BvChoiceLabelComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvChoice::Label': typeof BvChoiceLabelComponent;
    'bv-choice/label': typeof BvChoiceLabelComponent;
  }
}
